import { styled } from '@mui/material';
import { ArrowDropDownIcon, ArrowDropUpIcon, ZoomInIcon } from '../../assets';
import { getCompany } from '../../utils/company';
import { Companies } from '../../models/domain/enum';

const company = getCompany();

const getImageWrapperStyles: any = (theme: any) => {
  switch (company) {
    case Companies.SIRMAN:
      return {
        flexDirection: 'column',
      };
    case Companies.FELSINEA:
      return {
        flexDirection: 'row-reverse',
        [theme.breakpointsMediaQuery.down('md')]: {
          flexDirection: 'column',
        },
      };
    default:
      return;
  }
};

const getImgPreviewWrapperStyles: any = (theme: any) => {
  switch (company) {
    case Companies.SIRMAN:
      return {
        margin: `0 ${theme.spacings.unit(2)} 0 0`,
        flexDirection: 'row',
        flexWrap: 'wrap',
        minWidth: theme.spacings.unit(256 / 4),
        width: '100%',
      };
    case Companies.FELSINEA:
      return {
        flexDirection: 'column',
        maxHeight: '100%',
        flexWrap: 'wrap',
        [theme.breakpointsMediaQuery.down('md')]: {
          flexDirection: 'row',
        },
      };
    default:
      return;
  }
};

const getPreviewImgStyles: any = (theme: any) => {
  switch (company) {
    case Companies.SIRMAN:
      return {
        width: theme.spacings.unit(88 / 4),
        height: theme.spacings.unit(88 / 4),
      };
    case Companies.FELSINEA:
      return {
        width: theme.spacings.unit(78 / 4),
        height: theme.spacings.unit(78 / 4),
      };
    default:
      return;
  }
};

const getLargeImageStylesContainer: any = (theme: any) => {
  switch (company) {
    case Companies.SIRMAN:
      return {
        maxHeight: `calc(85vh - ${theme.spacings.unit(288 / 4)})`,
        width: '100%',
      };
    case Companies.FELSINEA:
      return {
        flexDirection: 'row-reverse',
        flexGrow: 1,
        [theme.breakpointsMediaQuery.down('md')]: {
          width: '100%',
        },
      };
    default:
      return;
  }
};

export const ImageViewerWrapper = styled('div')(({ theme }) => ({
  '#ReactSimpleImageViewer': {
    backgroundColor: theme.colors.halfOpacityDark,
    zIndex: 2000,
  },

  '.react-simple-image-viewer__close, .react-simple-image-viewer__previous, .react-simple-image-viewer__next':
    {
      opacity: 0.5,
    },
}));

export const ImageWrapper = styled((props) => <div {...props}></div>)(
  ({ theme }) => ({
    display: 'flex',
    overflow: 'hidden',
    overflowX: 'hidden',
    height: '100%',
    ...getImageWrapperStyles(theme),
    '& .MuiImageListItem-item': {
      aspectRatio: '1/1',
      overflow: 'hidden',
    },

    '& img': {
      // Keep it
      width: '100%',
      height: 'auto',
      aspectRatio: '1/1',
      cursor: 'pointer',
      mixBlendMode: 'multiply',
    },
  })
);

export const ExpandDiv = styled('div')(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacings.unit(2.5),
  right: theme.spacings.unit(2.5),
  pointerEvents: 'none',
  '@media print': {
    display: 'none',
  },
}));

export const LargeImageContainer = styled('div')(({ theme }) => ({
  margin: `0 0 ${theme.spacings.unit(2.5)} 0`,
  position: 'relative',
  alignSelf: 'flex-start',
  minWidth: theme.spacings.unit(256 / 4),
  background: theme.colors.secondaryBackground,
  mixBlendMode: 'multiply',
  aspectRatio: '1/1',
  overflow: 'hidden',
  '> span': {
    '> img': {
      transition: 'transform 0.15s ease',
    },
  },
  ...getLargeImageStylesContainer(theme),
}));

export const VideoPreviewContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.colors.black,
}));

export const ImgPreviewWrapper = styled('div')(({ theme }) => ({
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  ...getImgPreviewWrapperStyles(theme),
}));

export const StyledZoomInIcon = styled(ZoomInIcon)(({ theme }) => ({
  background: theme.colors.zoomInIconBg,
  color: theme.colors.zoomInIcon,
  width: theme.spacings.unit(9),
  height: theme.spacings.unit(9),
  padding: theme.spacings.unit(2),
  borderRadius: '50%',
}));

export const PreviewImg = styled('span', {
  shouldForwardProp: (prop) => prop !== 'isActive',
})(({ theme, isActive }) => ({
  mixBlendMode: 'multiply',
  border: isActive
    ? `1px solid ${theme.colors.primary}`
    : '1px solid transparent',
  position: 'relative',
  aspectRatio: '1/1',
  '&& > span': {
    padding: theme.spacings.unit(16 / 4),
  },
  background: theme.colors.secondaryBackground,
  marginRight: theme.spacings.unit(12 / 4),
  marginBottom: theme.spacings.unit(12 / 4),
  ...getPreviewImgStyles(theme),
}));

export const StyledArrowDropUpIcon = styled(ArrowDropUpIcon)(
  ({ theme, disabled, shouldRotate, display }) => ({
    color: disabled && theme.colors.disabled,
    cursor: disabled ? 'not-allowed' : 'pointer',
    transform: shouldRotate ? 'rotate(-90deg)' : '',
    display: display ? 'inline-block' : 'none',
    '@media print': {
      display: 'none',
    },
  })
);

export const StyledArrowDropDownIcon = styled(ArrowDropDownIcon)(
  ({ theme, disabled, shouldRotate, display }) => ({
    color: disabled && theme.colors.disabled,
    cursor: disabled ? 'not-allowed' : 'pointer',
    transform: shouldRotate ? 'rotate(-90deg)' : '',
    display: display ? 'inline-block' : 'none',
    '@media print': {
      display: 'none',
    },
  })
);
